// test6
(6 && 0);
